import type { IVoteOptimizationStrategy, VoteAllocation, VoteOptimizationInput } from "../vote-optimization-strategy"
import { calculateBeastDistribution } from "../vote-optimization"
import { STRATEGY_ICON } from "../vote-optimization-strategy-factory"

/**
 * Token-focused strategy: Optimizes vote distribution to maximize the number of a specific token received as bribe rewards.
 * Uses Beast-style algorithm: allocates variably by token-per-vote (above-average gauges get more, below-average get 0%),
 * producing uneven splits (e.g. 25%, 15%, 30%, 2%) rather than flat 20%. Fully dilution-aware.
 */
export class TokenFocusedVoteOptimizationStrategy implements IVoteOptimizationStrategy {
  calculateDistribution(input: VoteOptimizationInput): Array<VoteAllocation> | null {
    return calculateBeastDistribution(input.gaugeBribes, input.selectedVotePower, true)
  }

  getName(): string {
    return "Token"
  }

  getDescription(): string {
    return "Optimizes vote distribution to maximize the amount of a selected token received as bribe rewards."
  }

  getIcon() {
    return STRATEGY_ICON.TOKEN
  }
}
